exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ctt-modal{z-index:9999;position:absolute;left:50%;top:50%;transform:translate(-50%,-50%)}", ""]);

// exports
